import { Region } from '~/Api/Analytics/Region';
import Country from '~/Api/Country/Country';

export default class RegionAvailability {
	region: Region;

	// eslint-disable-next-line no-use-before-define
	subRegions: RegionAvailability[];

	countries: Country[];

	constructor(region: Region, subRegions: RegionAvailability[], countries: Country[]) {
		this.region = region;
		this.subRegions = subRegions;
		this.countries = countries;
	}

	containsCountry(code: string): boolean {
		return this.countries.find((country) => country.alpha2 === code) !== undefined;
	}
}
